import { Trans } from 'react-i18next';
import { FREE2EX_TRADE_APP_URL } from '@/shared/config';
import { openTradingTerminalUrl } from '@/shared/lib';

type Props = {
  tradingAccountKey: string;
  tradingPlatformName: string;
};

const OpenAccountResultNote = ({
  tradingAccountKey,
  tradingPlatformName,
}: Props) => (
  <p className="p6 text-secondary text-center mb-[1.6rem]">
    <Trans
      i18nKey="openAccount.successNote"
      components={{
        terminal: (
          <button
            type="button"
            onClick={() =>
              openTradingTerminalUrl(tradingAccountKey, tradingPlatformName)
            }
            className="text-primary-cyan cursor-pointer"
          />
        ),
        app: (
          <a
            href={FREE2EX_TRADE_APP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary-cyan"
          />
        ),
      }}
    />
  </p>
);

export { OpenAccountResultNote };
